module.exports = __webpack_public_path__ + "img/symbol_1.c656ec2d.png";